import moment from 'moment-timezone';

const getHumanReadableFormattedDate = ({
  value,
  t,
  timezone,
  format = 'verbose',
}) => {
  function otherDayMomentFormat(now) {
    const isSameYear = this.isSame(now, 'year');
    return isSameYear
      ? t(`dates:${format}.base`)
      : t(`dates:${format}.base_with_year`);
  }

  const formatterByType = {
    verbose: {
      lastDay: otherDayMomentFormat,
      sameDay: t('dates:verbose.today'),
      nextDay: otherDayMomentFormat,
      lastWeek: otherDayMomentFormat,
      nextWeek: otherDayMomentFormat,
      sameElse: otherDayMomentFormat,
    },
    friendly: {
      lastDay: t('dates:friendly.yesterday'),
      sameDay: t('dates:friendly.today'),
      nextDay: t('dates:friendly.tomorrow'),
      lastWeek: otherDayMomentFormat,
      nextWeek: otherDayMomentFormat,
      sameElse: otherDayMomentFormat,
    },
    short: {
      lastDay: t('dates:short.base'),
      sameDay: t('dates:short.base'),
      nextDay: t('dates:short.base'),
      lastWeek: t('dates:short.base'),
      nextWeek: t('dates:short.base'),
      sameElse: t('dates:short.base'),
    },
  };

  const date = moment.utc(value);

  if (timezone) {
    date.tz(timezone);
  }

  return date.calendar(null, formatterByType[format]);
};

export default getHumanReadableFormattedDate;
